var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9983 0C16.3904 0 20.8764 3.87976 21.8169 9C20.8764 14.1202 16.3904 18 10.9983 18C5.60617 18 1.1202 14.1202 0.179688 9C1.1202 3.87976 5.60617 0 10.9983 0ZM10.9983 16C15.2339 16 18.8583 13.052 19.7757 9C18.8583 4.94803 15.2339 2 10.9983 2C6.76265 2 3.13827 4.94803 2.22083 9C3.13827 13.052 6.76265 16 10.9983 16ZM10.9983 13.5C8.51303 13.5 6.49831 11.4853 6.49831 9C6.49831 6.51472 8.51303 4.5 10.9983 4.5C13.4835 4.5 15.4983 6.51472 15.4983 9C15.4983 11.4853 13.4835 13.5 10.9983 13.5ZM10.9983 11.5C12.379 11.5 13.4983 10.3807 13.4983 9C13.4983 7.6193 12.379 6.5 10.9983 6.5C9.61765 6.5 8.49831 7.6193 8.49831 9C8.49831 10.3807 9.61765 11.5 10.9983 11.5Z",
    fill: "black",
    fillOpacity: 0.48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPassword);
export default __webpack_public_path__ + "static/media/viewPassword.c8885750499a9ab24c5ef550b9f8b121.svg";
export { ForwardRef as ReactComponent };